import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Cookie } from 'ng2-cookies';
import { Observable } from 'rxjs';
import { StorgeService } from './storge.service';
@Injectable({
  providedIn: 'root'
})
export class NetService {
  userData: any;
  private headers = new HttpHeaders({
    'Authorization': `Bearer ${Cookie.get('auth-token')}`
  });

  constructor(
    private http: HttpClient,
    private storgeService: StorgeService
  ) {
   
  }

  private _get<T>(url: string, params?: any, config?: any): Observable<T> {
    const queryParams = this._getJavaQueryParams(url,params)
    return this.http.get<T>(url, {params: new HttpParams({fromObject: queryParams}), headers: this.headers});
  }
  private _getNoHeaders<T>(url: string, params?: any, config?: any): Observable<T> {
    const queryParams = this._getJavaQueryParams(url,params)
    return this.http.get<T>(url, {params: new HttpParams({fromObject: queryParams})});
  }
  private _post<T>(url: string, data: any, params?: any, config?: any): Observable<T> {
    const queryParams = this._getJavaQueryParams(url,params)
    return this.http.post<T>(url, data, {params: new HttpParams({fromObject: queryParams}), headers: this.headers});
  }
  private _put<T>(url: string, data: any, params?: any, config?: any): Observable<T> {
    const queryParams = this._getJavaQueryParams(url,params)
    return this.http.put<T>(url, data, {params: new HttpParams({fromObject: queryParams}), headers: this.headers});
  }
  private _patch<T>(url: string, data: any, params?: any, config?: any): Observable<T> {
    const queryParams = this._getJavaQueryParams(url,params)
    return this.http.patch<T>(url, data, {params: new HttpParams({fromObject: queryParams}), headers: this.headers});
  }
  private _delete<T>(url: string, data: any, params?: any, config?: any): any {
    const queryParams = this._getJavaQueryParams(url,params)
    return this.http.delete<T>(url, {params: new HttpParams({fromObject: queryParams}), headers: this.headers});
  }

  private _postLogin<T>(url: string, data: any, params?: any, config?: any): Observable<T> {
    const queryParams = this._getJavaQueryParams(url,params)
    return this.http.post<T>(url, data, {params: new HttpParams({fromObject: queryParams})});
  }
  
 
  getJavaApplicant<T>(url: string, params?: any, config?: any) {
    return this._get<T>(`${environment.applicantBaseUrl}/${url}`, params, config);
  }

  getJavaApplicantNoHeaders<T>(url: string, params?: any, config?: any) {
    return this._getNoHeaders<T>(`${environment.applicantBaseUrl}/${url}`, params, config);
  }

  postJavaCandidate<T>(route: any = null, data: any = null, queryParams = null) {
    return this._post<T>(`${environment.userBaseUrl}/${route}`, data);
  }

  postJavaCandidateLogin<T>(route: any = null, data: any = null, queryParams = null) {
    return this._postLogin<T>(`${environment.userBaseUrl}/${route}`, data);
  }

  postJavaCandidateText(route: any = null, data: any = null, queryParams = null) {
    return this.http.post(`${environment.userBaseUrl}/${route}`, data, {responseType: 'text', headers: this.headers});
  }


  getJavaUser<T>(url: string, params?: any, config?: any) {
    return this._get<T>(`${environment.userBaseUrl}/${url}`, params, config);
  }

  deleteJavaApplicant<T>(url: string, params?: any, config?: any) {
    return this._delete<T>(`${environment.userBaseUrl}/${url}`, params, config);
  }

  putJavaApplicant<T>(url: string, params?: any, config?: any) {
    return this._put<T>(`${environment.userBaseUrl}/${url}`, params, config);
  }

  postJavaNotification<T>(route: any, data: any = null, queryParams = null) {
    return this._post<T>(`${environment.baseUrlNotification}/${route}`, data, queryParams);
  }

  putJavaNotification<T>(route: any, data: any = null, queryParams = null): Observable<T> {
    return this._put<T>(`${environment.baseUrlNotification}/${route}`, data, queryParams);
  }

  getJavaNotification<T>(url: string, params?: any, config?: any) {
    return this._get<T>(`${environment.baseUrlNotification}/${url}`, params, config);
  }

  patchJavaNotification<T>(route: any, data: any = null, queryParams = null): Observable<T> {
    return this._patch<T>(`${environment.baseUrlNotification}/${route}`, data, queryParams);
  }

  postJavaMultipleFiles<T>(route: any, data: any = null, queryParams = null) {
    return this._post<T>(`${environment.userBaseUrl}/${route}`, data, queryParams);
  }

  getJavaNoHeaders<T>(route: any = null, data: any = null) {
    return this._get<T>(`${environment.userBaseUrl}/${route}`);
  }

  private _getJavaQueryParams(url: any,queryParams: any, deleteEmptyStrings = false) {
    this.userData = this.storgeService.getFromStorge('supportUser')
    if (!this.userData?.id) {
      return queryParams ?? {};
    }
    
    if (!queryParams && !url.includes('userId')) {
      queryParams = { userId: this.userData.id?.toLowerCase() };
    } else if ((queryParams && !('userId' in queryParams)) && !url.includes('userId')) {
      queryParams.userId = this.userData.id?.toLowerCase();
    }
    if (deleteEmptyStrings) {
      for (const p in queryParams) {
        if (queryParams[p] === null || queryParams[p] === undefined) {
          delete queryParams[p];
        }
      }
    }
    return queryParams;
  }

}
